<template>
  <div>
    <HeaderPageVue
      pageTitle="Pagamento Cancelados"
      pageSubTitle="Visualize e gerencie seus pagamento cancelados"
    />

    <v-row justify="end">
      <v-col cols="auto">
        <download-excel
          class="ml-auto mr-0"
          :data="pagamentos"
          :fields="json_fields"
          name="faturamento_detalhado.xls"
        >
          <v-btn
            small
            rounded
            elevation="0"
            outlined
            color="green"
            @click="exportToExcel()"
          >
            <span class="pr-1">Exportar</span>
            <v-icon small class="green--text"
              >mdi-file-document-outline
            </v-icon>
          </v-btn>
        </download-excel>
      </v-col>
    </v-row>

    <v-card class="box pa-7 mt-4" rounded="lg">
      <h5>Pesquisar</h5>

      <v-flex class="pt-5">
        <v-layout>
          <v-row>
            <v-col cols="2">
              <v-text-field
                label="Inicio"
                v-model="filters.beginDate"
                outlined
                dense
                @click="modalBegin = true"
              ></v-text-field>
              <v-dialog v-model="modalBegin" max-width="300px">
                <v-date-picker v-model="filters.beginDate"></v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Final"
                v-model="filters.endDate"
                outlined
                dense
                @click="modalEnd = true"
              ></v-text-field>
              <v-dialog v-model="modalEnd" max-width="300px">
                <v-date-picker v-model="filters.endDate"></v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Procurar"
                v-model="search"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col>
              <v-btn color="primary" dense @click="filter">FILTRAR</v-btn>
            </v-col>
          </v-row>
        </v-layout>
      </v-flex>
    </v-card>

    <v-card class="box pa-2 mt-10" rounded="lg">
      <v-data-table
        :headers="header"
        :items="pagamentos"
        :items-per-page="itemsPerPage"
        :search="search"
        :page.sync="page"
        hide-default-footer
        class=" box"
      >
        <template v-slot:item="{ item }">
          <tr style="cursor: pointer" @click="selectChargeback(item)">
            <td style="font-size: 13px">{{ item.transaction_id }}</td>
            <td style="font-size: 13px">
              {{ item.vehicle_request_id || '-' }}
              <v-icon
                v-if="item.vehicle_request_id"
                small
                @click="abrirReserva(item)"
                color="info"
              >
                open_in_new
              </v-icon>
            </td>
            <td style="font-size: 13px">
              {{ formatValue(item.total_value_charged) }}
            </td>
            <td style="font-size: 13px">{{ item.type || '-' }}</td>
            <td style="font-size: 13px">{{ formatValue(item.value) }}</td>
            <td style="font-size: 13px">{{ formatHour(item.created_at) }}</td>
            <td style="font-size: 13px">{{ item.name }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </div>
    </v-card>

    <v-dialog v-model="showDescription" width="450px">
      <v-card>
        <v-card-text style="padding: 16px">
          {{
            chargeback.observation_refound
              ? chargeback.observation_refound
              : chargeback.payment_observation
          }}
        </v-card-text>
        <v-card-actions class="text-center align-center">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click="showDescription = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import HeaderPageVue from '../public/HeaderPage.vue';
import CanceledPayment from '../../controllers/CanceledPayment';
import { format } from 'date-fns';

export default {
  components: { HeaderPageVue },
  data() {
    return {
      canceledPayment: new CanceledPayment(this.$resource),
      modalBegin: false,
      modalEnd: false,
      search: '',
      pagamentos: [],
      chargeback: [],
      itemsPerPage: 10,
      page: 1,
      pages: 1,
      showDescription: false,
      filters: {
        beginDate: '2023-07-01',
        endDate: '2023-07-05',
      },
      header: [
        {
          text: 'ID TRANSAÇÃO',
          align: 'start',
          value: 'transaction_id',
          sortable: true,
        },
        {
          text: 'ID RESERVA',
          align: 'start',
          value: 'vehicle_request_id',
          sortable: true,
        },
        {
          text: 'VALOR TRANSAÇÃO',
          align: 'start',
          value: 'total_value_charged',
          sortable: true,
        },
        {
          text: 'MOTIVO ESTORNO',
          align: 'start',
          value: 'type',
          sortable: true,
        },
        {
          text: 'VALOR ESTORNADO',
          align: 'start',
          value: 'value',
          sortable: true,
        },
        {
          text: 'DATA ESTORNO',
          align: 'start',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'USUÁRIO',
          align: 'start',
          value: 'name',
          sortable: true,
        },
      ],
      json_fields: {
        'ID TRANSAÇÃO': {
          field: 'transaction_id',
        },
        'ID RESERVA': {
          field: 'vehicle_request_id',
          callback: value => {
            return value ? value : '-';
          },
        },
        'VALOR TRANSAÇÃO': {
          field: 'total_value_charged',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'MOTIVO ESTORNO': {
          field: 'type',
          callback: value => {
            return value ? value : '-';
          },
        },
        'VALOR ESTORNADO': {
          field: 'value',
          callback: value => {
            return value ? this.formatValue(value) : '-';
          },
        },
        'DATA ESTORNO': {
          field: 'created_at',
          callback: value => {
            return value ? this.formatHour(value) : '-';
          },
        },
        USUÁRIO: {
          field: 'name',
          callback: value => {
            return value ? value : '-';
          },
        },
        'MOTIVO DETALHADO': {
          field: '',
          callback: value => {
            return value ? value : '-';
          },
        },
      },
    };
  },
  mounted() {
    if ('observation_refound' in this) {
      this.json_fields['MOTIVO DETALHADO'].field = 'observation_refound';
    } else {
      this.json_fields['MOTIVO DETALHADO'].field = 'payment_observation';
    }
  },
  created() {
    this.findCanceledPayments();
  },
  methods: {
    async findCanceledPayments() {
      await this.canceledPayment.findByFilters(this.filters).then(res => {
        this.pagamentos = res.data;
        this.pages = this.pagamentos.length / this.itemsPerPage;

        if (this.pagamentos.length % this.itemsPerPage != 0) {
          this.pages += 1;
        }
      });
    },

    filter() {
      this.findCanceledPayments();
    },

    selectChargeback(item) {
      this.chargeback = item;
      this.showDescription = true;
      console.log(item);
    },

    formatValue(value) {
      let valorFloat = parseFloat(value / 100);
      return 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
    },

    formatHour(valor) {
      return format(new Date(valor), 'DD/MM/YYYY HH:mm');
    },

    abrirReserva(item) {
      let routeData = this.$router.resolve(
        '/tcs/reserva/' + item.vehicle_request_id
      );
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style scoped>
.box {
  background-color: rgb(253, 252, 252);
  width: 100%;
}

h5 {
  color: rgb(102, 102, 102);
  font-weight: 400;
}
</style>
